import { getDocumentCookie } from '@tb-core/helpers/document-cookie';
import { RealObject } from '@tb-core/types';

/**
 * Returns users jwt access token
 * @return string | null
 */
export const getAccessToken = () => getDocumentCookie('access_token');

/**
 * Returns users CSRFToken
 * @return string | null
 */
export const getCSRFToken = () => getDocumentCookie('CSRFToken');

/**
 * Returns users jwt id token
 * @return string | null
 */
export const getIdToken = () => getDocumentCookie('id_token');

/**
 * Returns users jwt loyalty on the web token
 * @return string | null
 */
export const getLowToken = () => getDocumentCookie('low_token');

/**
 * Adds access token bearer header jwt to http headers
 */
export const setAccessTokenHeader = (headers: RealObject = {}) => {
    const accessToken = getAccessToken();

    setBearerTokenHeader(headers, accessToken);

    return headers;
};

/**
 * Adds csrf token header to http headers
 */
export const setCSRFTokenHeader = (headers: RealObject = {}) => {
    const CSRFToken = getCSRFToken();

    if (CSRFToken) {
        headers.CSRFToken = CSRFToken;
    }

    return headers;
};

/**
 * Adds id token bearer header jwt to http headers
 */
export const setIdTokenHeader = (headers: RealObject = {}) => {
    const idToken = getIdToken();

    setBearerTokenHeader(headers, idToken);

    return headers;
};

/**
 * Adds loyalty on the web bearer header jwt to http headers
 */
export const setLowTokenHeader = (headers: RealObject = {}) => {
    const lowToken = getLowToken();

    setBearerTokenHeader(headers, lowToken);

    return headers;
};

export const setBearerTokenHeader = (
    headers: RealObject = {},
    token: string | null
) => {
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    return headers;
};
